import { tv } from 'tailwind-variants';

// Flex variants for tailwind-variants
const flexStyles = tv({
    base: "iris:box-border",
    variants: {
        display: {
            flex: "iris:flex",
            "inline-flex": "iris:inline-flex",
            none: "iris:hidden",
        },
        smDisplay: {
            flex: "iris:sm:flex",
            "inline-flex": "iris:sm:inline-flex",
            none: "iris:sm:hidden",
        },
        mdDisplay: {
            flex: "iris:md:flex",
            "inline-flex": "iris:md:inline-flex",
            none: "iris:md:hidden",
        },
        lgDisplay: {
            flex: "iris:lg:flex",
            "inline-flex": "iris:lg:inline-flex",
            none: "iris:lg:hidden",
        },
        direction: {
            row: "iris:flex-row",
            "row-reverse": "iris:flex-row-reverse",
            col: "iris:flex-col",
            "col-reverse": "iris:flex-col-reverse",
        },
        smDirection: {
            row: "iris:sm:flex-row",
            "row-reverse": "iris:sm:flex-row-reverse",
            col: "iris:sm:flex-col",
            "col-reverse": "iris:sm:flex-col-reverse",
        },
        mdDirection: {
            row: "iris:md:flex-row",
            "row-reverse": "iris:md:flex-row-reverse",
            col: "iris:md:flex-col",
            "col-reverse": "iris:md:flex-col-reverse",
        },
        lgDirection: {
            row: "iris:lg:flex-row",
            "row-reverse": "iris:lg:flex-row-reverse",
            col: "iris:lg:flex-col",
            "col-reverse": "iris:lg:flex-col-reverse",
        },
        align: {
            start: "iris:items-start",
            center: "iris:items-center",
            end: "iris:items-end",
            stretch: "iris:items-stretch",
            baseline: "iris:items-baseline",
        },
        smAlign: {
            start: "iris:sm:items-start",
            center: "iris:sm:items-center",
            end: "iris:sm:items-end",
            stretch: "iris:sm:items-stretch",
            baseline: "iris:sm:items-baseline",
        },
        mdAlign: {
            start: "iris:md:items-start",
            center: "iris:md:items-center",
            end: "iris:md:items-end",
            stretch: "iris:md:items-stretch",
            baseline: "iris:md:items-baseline",
        },
        lgAlign: {
            start: "iris:lg:items-start",
            center: "iris:lg:items-center",
            end: "iris:lg:items-end",
            stretch: "iris:lg:items-stretch",
            baseline: "iris:lg:items-baseline",
        },
        justify: {
            start: "iris:justify-start",
            center: "iris:justify-center",
            end: "iris:justify-end",
            between: "iris:justify-between",
            around: "iris:justify-around",
            evenly: "iris:justify-evenly",
        },
        smJustify: {
            start: "iris:sm:justify-start",
            center: "iris:sm:justify-center",
            end: "iris:sm:justify-end",
            between: "iris:sm:justify-between",
            around: "iris:sm:justify-around",
            evenly: "iris:sm:justify-evenly",
        },
        mdJustify: {
            start: "iris:md:justify-start",
            center: "iris:md:justify-center",
            end: "iris:md:justify-end",
            between: "iris:md:justify-between",
            around: "iris:md:justify-around",
            evenly: "iris:md:justify-evenly",
        },
        lgJustify: {
            start: "iris:lg:justify-start",
            center: "iris:lg:justify-center",
            end: "iris:lg:justify-end",
            between: "iris:lg:justify-between",
            around: "iris:lg:justify-around",
            evenly: "iris:lg:justify-evenly",
        },
        wrap: {
            nowrap: "iris:flex-nowrap",
            wrap: "iris:flex-wrap",
            "wrap-reverse": "iris:flex-wrap-reverse",
        },
        smWrap: {
            nowrap: "iris:sm:flex-nowrap",
            wrap: "iris:sm:flex-wrap",
            "wrap-reverse": "iris:sm:flex-wrap-reverse",
        },
        mdWrap: {
            nowrap: "iris:md:flex-nowrap",
            wrap: "iris:md:flex-wrap",
            "wrap-reverse": "iris:md:flex-wrap-reverse",
        },
        lgWrap: {
            nowrap: "iris:lg:flex-nowrap",
            wrap: "iris:lg:flex-wrap",
            "wrap-reverse": "iris:lg:flex-wrap-reverse",
        },
        gap: {
            "0": "iris:gap-0",
            "1": "iris:gap-1",
            "2": "iris:gap-2",
            "3": "iris:gap-3",
            "4": "iris:gap-4",
        },
        smGap: {
            "0": "iris:sm:gap-0",
            "1": "iris:sm:gap-1",
            "2": "iris:sm:gap-2",
            "3": "iris:sm:gap-3",
            "4": "iris:sm:gap-4",
        },
        mdGap: {
            "0": "iris:md:gap-0",
            "1": "iris:md:gap-1",
            "2": "iris:md:gap-2",
            "3": "iris:md:gap-3",
            "4": "iris:md:gap-4",
        },
        lgGap: {
            "0": "iris:lg:gap-0",
            "1": "iris:lg:gap-1",
            "2": "iris:lg:gap-2",
            "3": "iris:lg:gap-3",
            "4": "iris:lg:gap-4",
        },
        gapX: {
            "0": "iris:gap-x-0",
            "1": "iris:gap-x-1",
            "2": "iris:gap-x-2",
            "3": "iris:gap-x-3",
            "4": "iris:gap-x-4",
        },
        smGapX: {
            "0": "iris:sm:gap-x-0",
            "1": "iris:sm:gap-x-1",
            "2": "iris:sm:gap-x-2",
            "3": "iris:sm:gap-x-3",
            "4": "iris:sm:gap-x-4",
        },
        mdGapX: {
            "0": "iris:md:gap-x-0",
            "1": "iris:md:gap-x-1",
            "2": "iris:md:gap-x-2",
            "3": "iris:md:gap-x-3",
            "4": "iris:md:gap-x-4",
        },
        lgGapX: {
            "0": "iris:lg:gap-x-0",
            "1": "iris:lg:gap-x-1",
            "2": "iris:lg:gap-x-2",
            "3": "iris:lg:gap-x-3",
            "4": "iris:lg:gap-x-4",
        },
        gapY: {
            "0": "iris:gap-y-0",
            "1": "iris:gap-y-1",
            "2": "iris:gap-y-2",
            "3": "iris:gap-y-3",
            "4": "iris:gap-y-4",
        },
        smGapY: {
            "0": "iris:sm:gap-y-0",
            "1": "iris:sm:gap-y-1",
            "2": "iris:sm:gap-y-2",
            "3": "iris:sm:gap-y-3",
            "4": "iris:sm:gap-y-4",
        },
        mdGapY: {
            "0": "iris:md:gap-y-0",
            "1": "iris:md:gap-y-1",
            "2": "iris:md:gap-y-2",
            "3": "iris:md:gap-y-3",
            "4": "iris:md:gap-y-4",
        },
        lgGapY: {
            "0": "iris:lg:gap-y-0",
            "1": "iris:lg:gap-y-1",
            "2": "iris:lg:gap-y-2",
            "3": "iris:lg:gap-y-3",
            "4": "iris:lg:gap-y-4",
        },
    },
});

export { flexStyles as default };
